import React, { Component } from "react";
import PropTypes from 'prop-types';
import {
    withStyles,
    Dialog,
    DialogContent,
    DialogActions,
    Button,
    DialogContentText,
    FormControlLabel,
    CircularProgress,
    Checkbox
} from '@material-ui/core/';

import {
    getByTextIdByLanguage
} from "../utils/Utils";

import QuestionUtils from "../utils/QuestionUtils";

class DeleteQuestionDialog extends Component {
    constructor(props) {
        super(props);

        this.questionUtils = new QuestionUtils(props.appContext);
        this.state = {
            question: props.question,
            progress: null,
            isDeleteText: true
        };
    }

    componentWillReceiveProps(nextProps) {
        this.setState({ question: nextProps.question, text: nextProps.text, texts: nextProps.texts });
    }

    onCancel() {
        const { onCancel } = this.props;
        if (onCancel)
            onCancel();
    }

    onDone() {
        let self = this;
        const { onDone } = this.props;
        const { question, isDeleteText } = this.state;

        this.setState({ progress: <CircularProgress /> });
        this.questionUtils.deleteQuestion(question, isDeleteText).then(() => {
            self.setState({ progress: null });
            if (onDone)
                onDone(question);
        }).catch((error) => {
            self.setState({ progress: error.message });
        });

    }

    render() {
        let self = this;
        let { question, isDeleteText, progress } = self.state;
        let { language, texts } = this.props
        let display = question.question[0].text;
        let text = getByTextIdByLanguage(texts, question.questionId, language);
        if (text) 
            display = text.text;

        console.log("DeleteQuestionDialog.render:", display );
        return (
            <Dialog
                maxWidth={'sm'}
                fullWidth={true}
                model="false"
                open={true}
            >
                <DialogContent>
                    <DialogContentText>This will delete the question {display}. Are you sure?</DialogContentText>
                    <FormControlLabel
                        control={<Checkbox
                            checked={isDeleteText}
                            onChange={(e) => {
                                self.setState({ isDeleteText: e.target.checked });
                            }}
                        />
                        }
                        label="Select to delete associated text content as well" />
                    </DialogContent>
                <DialogActions>
                    {progress}
                    <Button disabled={language !== 'en-us'} variant="contained" self={self} style={styles.button} onClick={(e) => { self.onDone() }}>Ok</Button>
                    <Button variant="contained" self={self} style={styles.button} onClick={(e) => { self.onCancel() }}>Cancel</Button>
                </DialogActions>
            </Dialog>
        )
    }
}

const styles = {
    div: {
        margin: 10
    },

    button: {
        margin: 10
    }
};

DeleteQuestionDialog.propTypes = {
    children: PropTypes.node,
    classes: PropTypes.object.isRequired
};


export default withStyles(styles)(DeleteQuestionDialog);
